import { SortEvent } from 'primeng/api';
import { altitudeArrayObserver } from 'src/app/model/altitudes.model';

export const customTableSortAltitude = (event: SortEvent) => {
  const { field, data, order } = event;

  if (!data) return [];

  return data.sort((a, b) => {
    const aValue = a[field as keyof typeof a];
    const bValue = b[field as keyof typeof b];

    if (!aValue && !bValue) return 0;
    if (!aValue) return 1;
    if (!bValue) return -1;

    const getAltitudeIndex = (value: string): number => {
      const index = altitudeArrayObserver.indexOf(value);
      return index === -1 ? Number.MAX_SAFE_INTEGER : index;
    };

    const aIndex = getAltitudeIndex(aValue as string);
    const bIndex = getAltitudeIndex(bValue as string);

    return (order ?? 1) * (aIndex - bIndex);
  });
};
